import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from '../baseApi';

export interface ApprovalRule {
  ID: number;
  PLANT: string;
  WORK_CENTER: string;
  MATERIAL_CATEGORY: string;
  APPROVAL_LEVEL: number;
  IS_ACTIVE: boolean;
  createdAt: string;
  updatedAt: string;
  members: ApprovalRuleMember[];
  plant: {
    PLANTDISPLAYNAME: string;
  };
}

export interface ApprovalRuleMember {
  ID: number;
  RULE_ID: number;
  APPROVER_NAME: string;
  APPROVER_ID: number | null;
  PLANT: string;
  IS_ACTIVE: boolean;
  createdAt: string;
  updatedAt: string;
  rule?: {
    WORK_CENTER: string;
    MATERIAL_CATEGORY: string;
  };
}

export interface CreateRuleRequest {
  plantName: string;
  workCenter: string;
  materialCategory: string;
  approvalLevel: number;
}

export interface WorkCenter {
  PLANTNAME: string;
  WORKCENTERNAME: string;
  WORKCENTERDESC: string;
}
export interface AddApproverRequest {
  ruleId: number;
  approverId: number;
  approverName: string;
  plant: string;
}



export const ruleApi = createApi({
  reducerPath: 'ruleApi',
  baseQuery: createBaseQuery('rule/'),
  tagTypes: ['Rules'],
  endpoints: (builder) => ({
    
    getAllRules: builder.query<
      { rules: ApprovalRule[]; pagination: any },
      { page: number; limit: number; q?: string }
    >({
      query: ({ page, limit, q }) =>
        `getAllRules?page=${page}&limit=${limit}&q=${q || ""}`,
      transformResponse: (response: {
        message: string;
        rules: ApprovalRule[];
        pagination: any;
      }) => ({
        rules: response.rules,
        pagination: response.pagination,
      }),
      providesTags: ['Rules'],
    }),
     getRulesByPlant: builder.query<
      { rules: ApprovalRule[] },
      string
    >({
      query: (plantCode) => `getRulesByPlant/${plantCode}`,
      transformResponse: (response: {
        message: string;
        rules: ApprovalRule[];
      }) => response,
      providesTags: ['Rules'],
    }),

    createRule: builder.mutation<ApprovalRule, CreateRuleRequest>({
      query: (body) => ({
        url: 'createRule',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Rules'],
    }),
    // getDistinctWorkCenters: builder.query<any, void>({
    //   query: () => 'getDistinctWorkCenters',
    // }),
    getDistinctMaterialCategories: builder.query<any, void>({
      query: () => 'getDistinctMaterialCategories',
    }),
    getDistinctPlants: builder.query<any, void>({
      query: () => 'getDistinctPlants',
    }),
    getAllPlants: builder.query<any, void>({
      query: () => 'getAllPlants',
    }),
    addApprover: builder.mutation<ApprovalRuleMember, AddApproverRequest>({
      query: (body) => ({
        url: 'addApprover',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Rules'],
    }),
    getAllApprovers: builder.query<ApprovalRuleMember[], void>({
      query: () => 'getAllApprovers',
      transformResponse: (response: { message: string; approvers: ApprovalRuleMember[] }) => response.approvers,
      providesTags: ['Rules'],
    }),
    deleteApprover: builder.mutation<{ message: string }, number>({
      query: (id) => ({
      url: `removeApprover/${id}`,
      method: "DELETE",
        }),
       invalidatesTags: ["Rules"],
    }),
    deleteRule: builder.mutation<{ message: string }, number>({
  query: (id) => ({
    url: `deleteRule/${id}`,
    method: "DELETE",
  }),
  invalidatesTags: ["Rules"],
})

  }),
});

export const { useGetAllRulesQuery,useGetRulesByPlantQuery, useCreateRuleMutation,  useGetDistinctMaterialCategoriesQuery, useGetDistinctPlantsQuery, useGetAllPlantsQuery, useAddApproverMutation, useGetAllApproversQuery,useDeleteApproverMutation ,useDeleteRuleMutation,} = ruleApi;
